function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("rect", {
  width: 19,
  height: 34
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "a",
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2 -1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.236-57.058a12.188,12.188,0,0,1,.8-3.726c.712-1.921,1.478-3.823,2.249-5.721.9-2.227,1.836-4.442,2.756-6.662a1.4,1.4,0,0,0,.134-.873.653.653,0,0,0-.719-.542,1.924,1.924,0,0,0-1.079.426,15.36,15.36,0,0,0-1.4,1.226c-.63.641-1.211,1.33-1.825,1.987a5.29,5.29,0,0,1-.689.609.531.531,0,0,1-.7,0,.608.608,0,0,1-.277-.7,2.062,2.062,0,0,1,.274-.578,11.379,11.379,0,0,1,.855-1.085,18.474,18.474,0,0,1,4.38-3.713A10.482,10.482,0,0,1,15.295-77.9a5.512,5.512,0,0,1,1.386.183,2.713,2.713,0,0,1,2.1,2.653,7.851,7.851,0,0,1-.631,3.233c-1.421,3.681-2.855,7.358-4.271,11.041a12.189,12.189,0,0,0-.419,1.457,1.107,1.107,0,0,0,.016.5.553.553,0,0,0,.67.452,2.459,2.459,0,0,0,.746-.279,8.384,8.384,0,0,0,1.763-1.511c.587-.608,1.159-1.232,1.747-1.84a5.119,5.119,0,0,1,.608-.528.417.417,0,0,1,.587.029.7.7,0,0,1,.254.824,4.656,4.656,0,0,1-.5.953,15.2,15.2,0,0,1-2.908,3.009,16.686,16.686,0,0,1-5.386,3.092,7.454,7.454,0,0,1-3.383.391,2.514,2.514,0,0,1-2.195-1.491,8.285,8.285,0,0,1-.307-1.311Z",
  transform: "translate(-1.822 88.417)",
  fill: "#014250"
}), /*#__PURE__*/React.createElement("path", {
  d: "M213.061-271.6a4.532,4.532,0,0,1-1.695-.282,3.239,3.239,0,0,1-2.009-3.378,4.2,4.2,0,0,1,3.668-3.752,4.319,4.319,0,0,1,1.938.149,3.305,3.305,0,0,1,2.286,3.749,4.129,4.129,0,0,1-3.478,3.435C213.49-271.631,213.206-271.612,213.061-271.6Z",
  transform: "translate(-197.266 280.29)",
  fill: "#014250"
})));

var SvgInfoIcon = function SvgInfoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 34,
    viewBox: "0 0 19 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/INFO_ICON.16effc1e.svg";
export { ForwardRef as ReactComponent };